import React, { Component } from 'react';
import irelandApi from '../../irelandApi';
import SiteLoader from '../layout/site-loader';
import { connect } from 'react-redux'
import { Grid, Row, Col } from 'react-bootstrap';
import PageTitle from '../common/page-title/index';
import MyIncentives from './my-incentives';

class MyIncentivesPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
        data: [],
        isLoading: true
    };
  }

  componentDidMount() {
    irelandApi.get('/api/store_performances').then(result => {
      this.setState({
          data: result.data.data,
          isLoading: false
      });
    });
  }

  render() {
    const { viewConfigLoaded, hasRewardOutlet } = this.props;
    const { isLoading, data } = this.state;

    if (!viewConfigLoaded || isLoading) {
      return <SiteLoader />;
    }

    return (
      <Grid bsClass="container">
        <Row>
          <Col lg={12}>
          <PageTitle>My Incentives</PageTitle>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
          { this.props.viewConfigLoaded &&
              <div id="my-incentives-and-rewards">
                { hasRewardOutlet && <MyIncentives data={data} /> }
              </div>
          }
          </Col>
        </Row>
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    viewConfigLoaded: state.viewConfig.loaded,
    hasRewardOutlet: state.viewConfig.profile.attributes['has-reward-outlet']
  };
};

export default connect(mapStateToProps)(MyIncentivesPage);



// WEBPACK FOOTER //
// ./src/components/my-incentives/index.jsx